import Sidebar from "../Common/Sidebar";

export default function ResearchLandingPage() {
  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar pagename="research" />

      <div className="flex-grow-1 d-flex flex-column bg-light py-5 px-5 ">
        <div>
          <h2 className="mb-0">Research</h2>
          <p className="text-muted">Coming Soon...</p>
        </div>
      </div>
    </div>
  );
}
